import {
  FORGE_GALLERY_PATH_SEGMENT,
  LEGACY_GALLERY_PATH_SEGMENT,
} from '../../routes/report/reportPaths';
import {isMountedInShell} from '../../shellRemote';
import {type AuthorType, type TopicColorMap} from './types';

export const AUTHOR_TYPES: AuthorType[] = [
  'All',
  'Community',
  'Partner',
  'W&B',
];

// Colors based on the plan (Blue, Purple, etc.) - can be adjusted
export const TOPIC_COLORS: TopicColorMap = {
  // Existing / Legacy
  Agents: {
    backgroundColor: '#FFB057', // Orange
    textColor: '#FFFFFF',
  },
  'Reinforcement Learning': {
    backgroundColor: '#D67DFF', // Purple
    textColor: '#FFFFFF',
  },
  RAG: {
    backgroundColor: '#D67DFF', // Purple
    textColor: '#FFFFFF',
  },
  Trust: {
    backgroundColor: '#2BC2D1', // Teal
    textColor: '#FFFFFF',
  },
  GenAI: {
    backgroundColor: '#F2F2F2', // Light Gray
    textColor: '#2B3038',
  },
  LLM: {
    backgroundColor: '#F2F2F2',
    textColor: '#2B3038',
  },
  Articles: {
    backgroundColor: '#F2F2F2',
    textColor: '#2B3038',
  },

  // Authors
  Community: {
    backgroundColor: '#E6F4F1', // Light Teal
    textColor: '#2B3038',
  },
  Partner: {
    backgroundColor: '#E6F4F1',
    textColor: '#2B3038',
  },
  'W&B': {
    backgroundColor: '#E6F4F1',
    textColor: '#2B3038',
  },

  // AI Agent Observability
  Evaluations: {
    backgroundColor: '#FFB057',
    textColor: '#2B3038',
  },
  'Agent building and monitoring': {
    backgroundColor: '#F2F2F2',
    textColor: '#2B3038',
  },
  Inference: {
    backgroundColor: '#F2F2F2',
    textColor: '#2B3038',
  },
  'Safety and scoring': {
    backgroundColor: '#F2F2F2',
    textColor: '#2B3038',
  },

  // Build Models
  'Computer vision': {
    backgroundColor: '#F2F2F2',
    textColor: '#2B3038',
  },
  'Building LLMs': {
    backgroundColor: '#F2F2F2',
    textColor: '#2B3038',
  },
  NLP: {
    backgroundColor: '#F2F2F2',
    textColor: '#2B3038',
  },
  'Model ops': {
    backgroundColor: '#F2F2F2',
    textColor: '#2B3038',
  },

  // About W&B
  'Product announcements': {
    backgroundColor: '#F2F2F2',
    textColor: '#2B3038',
  },
  Integrations: {
    backgroundColor: '#F2F2F2',
    textColor: '#2B3038',
  },
  Events: {
    backgroundColor: '#D67DFF',
    textColor: '#2B3038',
  },
  Podcast: {
    backgroundColor: '#F2F2F2',
    textColor: '#2B3038',
  },

  // Default fallback matching the reference image style
  default: {
    backgroundColor: '#F2F2F2',
    textColor: '#2B3038',
  },
};

export const AUTHOR_TAG_MAPPING: Record<string, AuthorType> = {
  // Map specific tags to author types if needed
  community: 'Community',
  partner: 'Partner',
  wandb: 'W&B',
  'weights-biases': 'W&B',
};

export type TopicItem = {
  name: string;
  link: string;
};

export type TopicGroup = {
  name: string;
  items: TopicItem[];
};

const tagLink = (linkForm: string) =>
  isMountedInShell()
    ? `/${FORGE_GALLERY_PATH_SEGMENT}/${linkForm}`
    : `/${LEGACY_GALLERY_PATH_SEGMENT}/blog/tag/${linkForm}`;

export const TOPIC_GROUPS: TopicGroup[] = [
  {
    name: 'AI agent observability',
    items: [
      {name: 'Evaluations', link: tagLink('evaluations')},
      {name: 'Agent building and monitoring', link: tagLink('agents')},
      {name: 'Inference', link: tagLink('inference')},
      {name: 'Safety and scoring', link: tagLink('safety-scoring')},
    ],
  },
  {
    name: 'Build models',
    items: [
      {name: 'Computer vision', link: tagLink('computer-vision')},
      {name: 'Building LLMs', link: tagLink('llm')},
      {name: 'NLP', link: tagLink('nlp')},
      {name: 'Model ops', link: tagLink('model-ops')},
    ],
  },
  {
    name: 'About Weights & Biases',
    items: [
      {name: 'Product announcements', link: tagLink('feature-releases')},
      {name: 'Integrations', link: tagLink('framework-integration')},
      {name: 'Events', link: 'https://wandb.ai/site/resources/events/'},
      {name: 'Podcast', link: 'https://wandb.ai/site/resources/podcast/'},
    ],
  },
];
